import React from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import PropTypes from "prop-types";
import Form from "react-bootstrap/Form";

export default function MyNavbar(props) {
  return (
    <>
      <Navbar
        sticky="top"
        expand="lg"
        className="bg-body-tertiary"
        data-bs-theme={props.mode}
      >
        <Container fluid>
          <Navbar.Brand>{props.title}</Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
                <Nav.Link
                  onClick={() => {
                    return (document.title = "TextUtils - Home");
                  }}
                >
                  {" "}
                  Home
                </Nav.Link>
                <Nav.Link
                  onClick={() => {
                    return (document.title = "TextUtils - About");
                  }}
                >
                  About
                </Nav.Link>
            </Nav>

            <Form.Check
              className={`mb-auto mt-2 text-${
                props.textColor === "light" ? "dark" : "light"
              }`}
              type="switch"
              id="custom-switch"
              label={props.modeText}
              onClick={props.toggleMode}
            />
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
}

MyNavbar.propTypes = {
  title: PropTypes.string.isRequired,
};
MyNavbar.defaultProps = {
  title: "Something",
};
